import React, { useState, useEffect, useRef } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiChevronDown, FiSearch, FiCheck, FiUser } from 'react-icons/fi';

const CustomerSelector = ({ customers, value, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [filter, setFilter] = useState('');
    const dropdownRef = useRef(null);

    // Find selected customer object by name (since value is customer name string)
    const selectedCustomer = customers.find(c => c.name === value);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (customer) => {
        onChange(customer.name);
        setIsOpen(false);
        setFilter('');
    };

    const filteredCustomers = customers.filter(c =>
        c.name.toLowerCase().includes(filter.toLowerCase())
    );

    return (
        <div className="relative" ref={dropdownRef}>
            <div
                onClick={() => setIsOpen(!isOpen)}
                className={`w-full border rounded-lg p-2 bg-white flex items-center justify-between cursor-pointer transition-all ${isOpen ? 'border-[#16a34a] ring-2 ring-[#16a34a]/10' : 'border-gray-200 hover:border-[#16a34a]'}`}
            >
                {selectedCustomer ? (
                    <div className="flex items-center space-x-3 overflow-hidden">
                        <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden border border-gray-100 flex-shrink-0">
                            {selectedCustomer.image ? (
                                <img src={selectedCustomer.image} alt="" className="w-full h-full object-cover" />
                            ) : (
                                <SafeIcon icon={FiUser} className="text-gray-400 text-xs" />
                            )}
                        </div>
                        <span className="text-sm font-medium text-gray-900 truncate">{selectedCustomer.name}</span>
                    </div>
                ) : (
                    <span className="text-sm font-light text-gray-500 pl-1">Select Customer</span>
                )}
                <SafeIcon icon={FiChevronDown} className={`text-gray-400 transition-transform flex-shrink-0 ml-2 ${isOpen ? 'rotate-180' : ''}`} />
            </div>

            {isOpen && (
                <div className="absolute z-50 mt-1 w-full bg-white border border-gray-100 rounded-xl shadow-xl max-h-60 overflow-hidden flex flex-col">
                    <div className="p-2 border-b border-gray-50 bg-gray-50/50">
                        <div className="flex items-center space-x-2 bg-white border border-gray-200 rounded-lg px-2 py-1.5 focus-within:border-[#16a34a] focus-within:ring-2 focus-within:ring-[#16a34a]/10 transition-all">
                            <SafeIcon icon={FiSearch} className="text-gray-400" />
                            <input
                                type="text"
                                placeholder="Search customer..."
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                className="w-full outline-none text-xs font-light bg-transparent"
                                autoFocus
                                onClick={(e) => e.stopPropagation()}
                            />
                        </div>
                    </div>
                    <div className="overflow-y-auto p-1 custom-scrollbar">
                        {filteredCustomers.length > 0 ? filteredCustomers.map(customer => (
                            <div
                                key={customer.id}
                                onClick={(e) => { e.stopPropagation(); handleSelect(customer); }}
                                className={`flex items-center space-x-3 p-2 rounded-lg cursor-pointer transition-colors ${selectedCustomer?.id === customer.id ? 'bg-green-50' : 'hover:bg-gray-50'}`}
                            >
                                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden border border-gray-100 flex-shrink-0">
                                    {customer.image ? (
                                        <img src={customer.image} alt="" className="w-full h-full object-cover" />
                                    ) : (
                                        <SafeIcon icon={FiUser} className="text-gray-400 text-xs" />
                                    )}
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="flex justify-between items-center">
                                        <p className={`text-sm truncate ${selectedCustomer?.id === customer.id ? 'font-medium text-[#16a34a]' : 'font-light text-gray-900'}`}>{customer.name}</p>
                                    </div>
                                    {customer.paymentTerm && <p className="text-[10px] text-gray-400">{customer.paymentTerm}</p>}
                                </div>
                                {selectedCustomer?.id === customer.id && <SafeIcon icon={FiCheck} className="text-[#16a34a] flex-shrink-0" />}
                            </div>
                        )) : (
                            <div className="p-4 text-center text-gray-400 text-xs font-light">No customers found</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CustomerSelector;
